module.exports = __webpack_public_path__ + "media/components/country-flag/static/cw-35c9593c02163ceae8adaf362ce4375a.svg";